import { createPortal } from 'react-dom'
import { JSX } from 'react'
import { AnimatePresence } from 'framer-motion'

import { MOTION } from 'styles/consts'
import * as Styled from './styled'

interface IPositionOptions {
  width: number
  left: number
  verticalPosition: number
  verticalAnimationPosition: number
  availableHeight: string
}

interface IProps {
  isOpen: boolean
  content: JSX.Element
  setRef: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
  positionOptions: IPositionOptions
  overlayClassName?: string
}

export const DropdownOverlay: React.FC<IProps> = props => {
  const { isOpen, content, setRef, positionOptions, overlayClassName } = props
  const {
    width,
    left,
    verticalPosition,
    verticalAnimationPosition,
    availableHeight
  } = positionOptions

  return createPortal(
    <AnimatePresence initial={false}>
      {isOpen && (
        <Styled.DropdownOverlayWrapper
          ref={setRef}
          initial={{ y: 0, opacity: 0, scale: 0.98 }}
          animate={{ y: verticalAnimationPosition, opacity: 1, scale: 1 }}
          exit={{
            y: 0,
            opacity: 0,
            scale: 0.98,
            transition: {
              ease: MOTION.ease.out,
              duration: MOTION.duration.fast
            }
          }}
          transition={{
            ease: MOTION.ease.out,
            duration: MOTION.duration.base
          }}
          width={width}
          left={left}
          top={verticalPosition}
          height={availableHeight}
          className={overlayClassName}
        >
          {content}
        </Styled.DropdownOverlayWrapper>
      )}
    </AnimatePresence>,
    document.getElementsByTagName('body')[0]
  )
}
